import styled, {css} from 'styled-components';

import ArrowRightIcon from '../../assets/icons/secondary/Arrow - Right 2.svg';
import {ms} from '../../styles/normalizeSize';
import {getColor} from '../../styles/utils';
import {Text} from '../../uikit/Text';
import {TextArea} from '../../uikit/TextArea';
import {TextInput} from '../../uikit/TextInput';
import {
  TextInputLikeText,
  TextInputLikeView,
} from '../../uikit/TextInputLikeView';
import {View} from '../../uikit/View';

export const Section = styled(View)<{fullWidth?: boolean; isFirst?: boolean}>`
  margin: ${p => ms(p.isFirst ? 0 : 24)} ${p => ms(p.fullWidth ? 0 : 20)} 0;
  flex-direction: column;
  flex-grow: 1;
  flex-basis: 0;
  position: relative;
`;

export const Row = styled(View)<{spaceBetween?: boolean}>`
  display: flex;
  flex-flow: row wrap;
  column-gap: ${ms(20)};

  @media (max-width: 850px) {
    display: block;

    ${Section}:last-child {
      margin-top: ${ms(24)};
    }
  }

  ${p =>
    p.spaceBetween &&
    css`
      justify-content: space-between;
    `}
`;

export const LabelContainer = styled(View)`
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const Label = styled(Text)<{fullWidth?: boolean; optional?: boolean}>`
  font-size: ${ms(14)};
  line-height: ${ms(20)};
  margin-bottom: ${ms(8)};

  ${p =>
    p.optional &&
    css`
      color: ${getColor('text3')};
    `}

  ${p =>
    p.fullWidth &&
    css`
      margin-left: ${ms(20)};
      margin-right: ${ms(20)};
    `}
`;

const STextInput = styled(TextInput)``;

const STextArea = styled(TextArea)`
  height: ${ms(100)};
  resize: vertical;
`;

export {STextArea as TextArea, STextInput as TextInput};

const STextInputLikeView = styled(TextInputLikeView)`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-right: ${ms(8)};
  padding-top: ${ms(12)};
  padding-bottom: ${ms(12)};
`;

const STextInputLikeText = styled(TextInputLikeText)<{isEmpty?: boolean}>`
  ${p =>
    p.isEmpty &&
    css`
      color: ${getColor('text3')};
    `}
`;

export {
  STextInputLikeText as TextInputLikeText,
  STextInputLikeView as TextInputLikeView,
};

export const ArrowRight = styled(ArrowRightIcon).attrs(p => ({
  fill: getColor('icon3')(p),
}))`
  width: ${ms(24)};
  height: ${ms(24)};
`;

export const OptionsWrapper = styled(View)`
  position: relative;
  overflow-y: auto;
  height: ${ms(47)};
`;

export {OptionsContainer} from './OptionsContainer';

export const Option = styled(View)<{
  isDisabled?: boolean;
  isLast: boolean;
  isSelected: boolean;
}>`
  padding: ${ms(10)} ${ms(14)};
  height: ${ms(47)};
  border-radius: ${ms(8)};
  margin-right: ${ms(15)};
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${getColor('background2')};
  border: 1px solid ${getColor('background2')};

  ${p =>
    p.isLast &&
    css`
      margin-right: 0;
    `}

  ${p =>
    p.isSelected &&
    css`
      background-color: ${getColor('background4')(p)};
      border: 1px solid ${getColor('global1')};
    `}

    ${p =>
    p.isDisabled &&
    css`
      opacity: 0.6;
    `}
`;

export const OptionText = styled(Text)<{isSelected: boolean}>`
  font-size: 14px;
  color: ${getColor('text3')};

  ${p =>
    p.isSelected &&
    css`
      color: ${getColor('text4')};
    `}
`;
